import React, { useEffect } from 'react'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { useAppDispatch } from 'app/hooks'
import { resetInsightContent } from 'features/insightContent/insightContentSlice'

const DIALOG_WIDTH = '800px'

interface InsightDialogProps {
  children: React.ReactNode
  open: boolean
  onClose: () => void
  width?: string
}

const InsightDialog = ({ children, open, onClose, width = DIALOG_WIDTH }: InsightDialogProps) => {
  const theme = useDisplayTheme() as Theme
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (open) {
      dispatch(resetInsightContent())
    }
  }, [open, dispatch])

  return (
    <Dialog mode={theme} open={open} onClose={onClose} disableBackdropClick width={width}>
      {open && children}
    </Dialog>
  )
}

export default InsightDialog
